import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, Fragment, useEffect, forwardRef } from 'react';
import AddressFormComponent from '../../elements/address-lookup';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var AddressInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var lookup = _ref.lookup,
      label = _ref.label,
      name = _ref.name,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      error = _ref.error,
      formVariant = _ref.formVariant;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      address = _useState2[0],
      setAddress = _useState2[1];

  var handleAddressChange = function handleAddressChange(key, addrs) {
    setAddress(addrs);
  };

  useEffect(function () {
    onChange(address);
  }, [address]);
  return _jsxs(Fragment, {
    children: [_jsx("input", {
      type: "hidden",
      id: "addressInput",
      name: name,
      ref: ref,
      value: JSON.stringify(address)
    }), _jsx(AddressFormComponent, {
      label: label,
      lookup: lookup,
      onChange: handleAddressChange,
      error: error,
      formVariant: formVariant,
      hasTimeAtAddress: false
    })]
  });
});
export default AddressInput;
//# sourceMappingURL=index.js.map